import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Tender } from '../../../../models';
import { TenderBidsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'jft-tender-tabs',
    templateUrl: './tender-tabs.component.html',
    styleUrls: ['./tender-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderTabsComponent implements OnInit, OnDestroy {

    public tender: Tender;

    public term: string;

    constructor(
        private route: ActivatedRoute,
    ) {
    }

    public ngOnInit() {
        let data = this.route.parent.snapshot.data;
        this.tender = data['tender'];
    }

    public ngOnDestroy(): void {
    }

}
